module.exports = __webpack_public_path__ + "img/P2-C4.715f14da.svg";